import React from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';

type TranscriptEntry = {
  source: string;
  message: string;
  timestamp: string;
};

interface AssessmentTranscriptProps {
  isOpen: boolean;
  onClose: () => void;
  transcript?: TranscriptEntry[];
}

const AssessmentTranscript: React.FC<AssessmentTranscriptProps> = ({
  isOpen,
  onClose,
  transcript
}) => {
  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent side="right" className="w-[400px] sm:w-[540px] flex flex-col">
        <SheetHeader>
          <SheetTitle>Assessment Transcript</SheetTitle>
        </SheetHeader>
        <div className="mt-6 flex-1 overflow-y-auto px-2 custom-scrollbar">
          <div className="space-y-4">
            {Array.isArray(transcript) ? (
              transcript.map((entry: TranscriptEntry, index: number) => {
                const isAI = entry.source.toLowerCase() === 'ai';
                const initials = isAI ? 'AI' : entry.source.split(' ').map(n => n[0]).join('').toUpperCase();
                
                return (
                  <div key={index} className={`flex ${isAI ? 'justify-start' : 'justify-end'} items-start gap-3 mb-4`}>
                    {isAI && (
                      <Avatar className="h-8 w-8 shrink-0">
                        <AvatarFallback className="bg-roundone-purple/10 text-roundone-purple text-sm">
                          {initials}
                        </AvatarFallback>
                      </Avatar>
                    )}
                    
                    <div className={`flex flex-col space-y-1 max-w-[80%]`}>
                      <div className={`rounded-lg p-3 ${
                        isAI ? 'bg-muted' : 'bg-roundone-purple text-white'
                      }`}>
                        <p className="text-sm whitespace-pre-wrap">{entry.message}</p>
                      </div>
                      <span className="text-xs text-muted-foreground px-1">
                        {new Date(entry.timestamp).toLocaleTimeString([], { 
                          hour: '2-digit', 
                          minute: '2-digit'
                        })}
                      </span>
                    </div>

                    {!isAI && (
                      <Avatar className="h-8 w-8 shrink-0">
                        <AvatarFallback className="bg-roundone-purple text-white text-sm">
                          {initials}
                        </AvatarFallback>
                      </Avatar>
                    )}
                  </div>
                );
              })
            ) : (
              <div className="flex items-center justify-center h-40 text-muted-foreground">
                No transcript available.
              </div>
            )}
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default AssessmentTranscript; 